const LiveDonations = () => {
  const donations = [
    { name: "Brian S", amount: 10, campaign: "Stand With Crystal" },
    { name: "Anonymous Giver", amount: 5, campaign: "The Giver Army Fund" },
    { name: "She did what she could", amount: 5, campaign: "PrayGiveGODefense Fund" },
    { name: "Anonymous Giver", amount: 100, campaign: "Stand With Crystal" },
    { name: "Anonymous Giver", amount: 50, campaign: "Derek Chauvin Legal Defense Fund" },
    { name: "She did what she could", amount: 25, campaign: "PrayGiveGODefense Fund" },
    { name: "Anonymous Giver", amount: 5, campaign: "Stand With Crystal" },
    { name: "Anonymous Giver", amount: 5, campaign: "Help Support Real Raw News" },
    { name: "Anonymous Giver", amount: 10, campaign: "Stand With Crystal" },
    { name: "Anonymous Giver", amount: 50, campaign: "Support DonatePe" },
    { name: "Anonymous Giver", amount: 10, campaign: "Funeral Expenses" },
    { name: "Anonymous Giver", amount: 30, campaign: "Stand With Crystal" },
    { name: "Lynn", amount: 20, campaign: "Stand With Crystal" },
    { name: "Anonymous Giver", amount: 20, campaign: "Old State Saloon Under Fire Help Us Fight Back" },
    { name: "Emily Buckwalter", amount: 200, campaign: "Luca's Big Adventure" }
  ]

  return (
    <section className="pt-0 pb-14 px-4">
      <div className="flex flex-row justify-start mx-auto bg-white rounded-lg shadow-lg cursor-pointer max-w-[1920px] whitespace-nowrap overflow-hidden">
        <div className="flex flex-row items-center px-6 text-white rounded-tl-lg rounded-bl-lg marquee__label">
          <p className="font-semibold">Our Givers</p>
        </div>
        
        <div className="py-3 marquee-container flex-grow">
          <div className="marquee">
            {[...donations, ...donations].map((donation, index) => (
              <p key={index} className="marquee__donation inline-block mx-5 text-gsg-gray-dark">
                <span className="font-semibold">{donation.name}</span> just gave USD $ {donation.amount} to{' '}
                <a href={`/${donation.campaign.replace(/\s+/g, '')}`} className="text-gsg-teal hover:text-gsg-teal-dark">
                  {donation.campaign}
                </a>
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default LiveDonations